import { render, staticRenderFns } from "./CrmTextIcon.vue?vue&type=template&id=0fc9625c&"
import script from "./CrmTextIcon.vue?vue&type=script&lang=ts&"
export * from "./CrmTextIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports